import {
  Directive, EventEmitter, HostBinding, Input, Output, TemplateRef, OnInit, OnDestroy, ElementRef, Renderer } from '@angular/core';
import { TabsetComponent } from './tabset.component';


export class TabDirective implements OnInit, OnDestroy {
  /** tab header text */
   public heading: string;
  /** tab id */
   public id: string;
  /** if true tab can not be activated */
   public disabled: boolean;
  /** if true tab can be removable, additional button will appear */
   public removable: boolean;
  /** if set, will be added to the tab's class atribute */
   public get customClass(): string {
    return this._customClass;
  }

  public set customClass(customClass: string) {
    if (this._customClass && this._customClass !== customClass) {
      this.renderer.setElementClass(this.elementRef.nativeElement, this._customClass, false);
    }

    this._customClass = customClass;

    if (this._customClass) {
      this.renderer.setElementClass(this.elementRef.nativeElement, this._customClass, true);
    }
  }

  /** tab active state toggle */
  
  
  public get active(): boolean {
    return this._active;
  }

  public set active(active: boolean) {
    if (this.disabled && active || !active) {
      if (!active) {
        this._active = active;
      }

      this.deselect.emit(this);
      return;
    }

    this._active = active;
    this.select.emit(this);
    this.tabset.tabs.forEach((tab: TabDirective) => {
      if (tab !== this) {
        tab.active = false;
      }
    });
  }

  /** fired when tab became active, $event:Tab equals to selected instance of Tab component */
   public select: EventEmitter<TabDirective> = new EventEmitter();
  /** fired when tab became inactive, $event:Tab equals to deselected instance of Tab component */
   public deselect: EventEmitter<TabDirective> = new EventEmitter();
  /** fired before tab will be removed, $event:Tab equals to instance of removed tab */
   public removed: EventEmitter<TabDirective> = new EventEmitter();

   public addClass: boolean = true;

  public headingRef: TemplateRef<any>;
  public tabset: TabsetComponent;
  protected _active: boolean;
  protected _customClass: string;

  public constructor(tabset: TabsetComponent, public elementRef: ElementRef, public renderer: Renderer) {
    this.tabset = tabset;
    this.tabset.addTab(this);
  }

  public ngOnInit(): void {
    this.removable = this.removable;
  }

  public ngOnDestroy(): void {
    this.tabset.removeTab(this, {reselect: false, emit: false});
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: 'tab, [tab]'}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TabsetComponent, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'heading': [{ type: Input },],
'id': [{ type: Input },],
'disabled': [{ type: Input },],
'removable': [{ type: Input },],
'customClass': [{ type: Input },],
'active': [{ type: HostBinding, args: ['class.active', ] },{ type: Input },],
'select': [{ type: Output },],
'deselect': [{ type: Output },],
'removed': [{ type: Output },],
'addClass': [{ type: HostBinding, args: ['class.tab-pane', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
